import LegalPage from './LegalPage';
import { privacy } from './legal';

export default function PrivacyPolicy() {
  return <LegalPage doc={privacy} />;
}
